let draft = null;

export const setPublicidadDraft = (next) => {
  draft = next || null;
};

export const takePublicidadDraft = (destination) => {
  if (!draft) return null;
  if (destination && draft.destination !== destination) return null;
  const current = draft;
  draft = null;
  return current;
};

export const peekPublicidadDraft = () => draft;
